export default function parseRange(range) {
  if (!range) return [];
  return range.includes('-') ? range.split('-') : range.split(' ');
}
